import * as z from "zod";
import { isForeignKeyViolation } from "../dbErrors";
import { mutator } from "./mutator";

/**
 * Telemetry mutator that fires during normal navigation. Uses
 * `swallowError: true` on both workflow and branch so a benign race
 * (workflow/branch deleted while the user is still on the page, or
 * stale Zero state) no-ops instead of throwing.
 */
export const touchPresence = mutator({
  schema: z.object({
    workflowId: z.string(),
    branchId: z.string(),
    stepDir: z.string().optional(),
  }),
  resolve: {
    workflow: {
      kind: "workflow",
      from: "workflowId",
      swallowError: true,
    },
    branch: {
      kind: "branch",
      from: "branchId",
      swallowError: true,
    },
  },
  // Presence rows are shown to everyone who can read the branch, so being
  // present requires being able to read the space. Skipped when the
  // workflow resolved to null (deletion race); the fn then no-ops.
  permissions: [
    {
      permission: "space:read",
      scopeId: ({ args }) => args.workflow?.spaceId ?? null,
    },
  ],
  fn: async ({ tx, ctx, args: { stepDir, workflow, branch } }) => {
    if (!workflow || !branch || branch.workflowId !== workflow.id) return;
    const { userId } = ctx;
    try {
      await tx.mutate.userBranchPresence.upsert({
        userId,
        workflowId: workflow.id,
        branchId: branch.id,
        stepDir: stepDir ?? null,
        lastSeenAt: Date.now(),
        tenantId: ctx.tenantId,
      });
    } catch (e) {
      if (isForeignKeyViolation(e)) return;
      throw e;
    }
  },
});
